import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";
import { SettingsPage } from "@/nav/SettingsPage";

const settingsScreens = {
  "documents": page(() => import("@/screens/hr/Documents")),
  "background-checks": page(() => import("@/screens/hr/BackgroundChecks")),
  "import": page(() => import("@/screens/hr/Import")),
};

export const peopleRoutes: RouteObject[] = [
  {
    path: "/hr",
    children: [
      { id: "people.dashboard", index: true, element: page(() => import("@/screens/hr/Dashboard")) },
      { id: "people.people", path: "people", element: page(() => import("@/screens/hr/People")) },
      { id: "people.new", path: "people/new", element: page(() => import("@/screens/hr/NewEmployee")) },
      { id: "people.person", path: "people/:id", element: page(() => import("@/screens/hr/EmployeeDetail")) },
      { id: "people.org-chart", path: "org-chart", element: page(() => import("@/screens/hr/OrgChart")) },
      { id: "people.approvals", path: "approvals", element: page(() => import("@/screens/hr/Approvals")) },
      { id: "people.leave.calendar", path: "leave", element: page(() => import("@/screens/hr/leave/Calendar")) },
      { id: "people.leave.me", path: "leave/me", element: page(() => import("@/screens/hr/leave/MyLeave")) },
      { id: "people.leave.team", path: "leave/team", element: page(() => import("@/screens/hr/leave/TeamLeave")) },
      { id: "people.training", path: "training", element: page(() => import("@/screens/hr/Training")) },
      { id: "people.time", path: "time", element: page(() => import("@/screens/hr/Time")) },
      { id: "people.lifecycle", path: "lifecycle", element: page(() => import("@/screens/hr/Lifecycle")) },
      { id: "people.lifecycle.run", path: "lifecycle/:id", element: page(() => import("@/screens/hr/LifecycleRunDetail")) },
      { id: "people.expenses", path: "expenses", element: page(() => import("@/screens/hr/Expenses")) },
      { id: "people.performance", path: "performance", element: page(() => import("@/screens/hr/Performance")) },
      { id: "people.recruitment", path: "recruitment", element: page(() => import("@/screens/hr/Recruitment")) },
      { id: "people.cases", path: "cases", element: page(() => import("@/screens/hr/Cases")) },
      { id: "people.case", path: "cases/:id", element: page(() => import("@/screens/hr/CaseDetail")) },
      { id: "people.payroll", path: "payroll", element: page(() => import("@/screens/hr/Payroll")) },
      { id: "people.settings", path: "settings/:tab?", element: <SettingsPage itemId="hr-settings" screens={settingsScreens} /> },
    ],
  },
];
